import { render, staticRenderFns } from "./package-form.vue?vue&type=template&id=6ae480ad&scoped=true"
import script from "./package-form.vue?vue&type=script&setup=true&lang=js"
export * from "./package-form.vue?vue&type=script&setup=true&lang=js"
import style0 from "./package-form.vue?vue&type=style&index=0&id=6ae480ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae480ad",
  null
  
)

export default component.exports